export const arraySplit = (arr, size) => arr.reduce((acc, v) => {
    if (acc.length === 0)
        acc.push([]);
    if (acc[acc.length - 1].length === size)
        acc.push([]);
    acc[acc.length - 1].push(v);
    return acc;
}, []);
